export default __webpack_public_path__ + "media/images/client/blur_content-d6bb539331ff5375c2a232abe30d7edd.png";